import React from "react";
import { SectionHeader } from "@/components/design-system/SectionHeader/SectionHeader";
import { BenefitCard } from "@/components/design-system/BenefitCard/BenefitCard";
import { benefits } from "./CreditUnionBenefitsSection.data";

export const CreditUnionBenefitsSection: React.FC = () => (
  <section className="w-full overflow-hidden bg-neutral-100">
    <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
      <div className="mb-12 md:mb-16">
        <SectionHeader
          label="For Credit Unions"
          heading={<>What your credit union{" "}<span className="text-primary-500">gains.</span></>}
          description="Provide a modern financial experience that keeps members coming back — while boosting cross-sell opportunities for your organization."
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-4 xl:mx-auto xl:max-w-282">
        {benefits.map((benefit) => (
          <BenefitCard
            key={benefit.title}
            icon={<benefit.Icon className="h-16 w-16" />}
            title={benefit.title}
            description={benefit.description}
          />
        ))}
      </div>
    </div>
  </section>
);
